import { render } from "./ExportVchRecord.vue?vue&type=template&id=f3e674ae&ts=true"
import script from "./ExportVchRecord.vue?vue&type=script&lang=ts"
export * from "./ExportVchRecord.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__